<template>
  <section class="l-content full relative page-bg">
    <head-panel v-if="statData" :config="config" :condition="condition" @change="change"></head-panel>
    <chart-container v-if="statData" :stat-data="statData" :config="config"></chart-container>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import ChartContainer from './statistic/chartContainer.vue'
import HeadPanel from './statistic/headPanel.vue'
export default {
  computed: {
    ...mapState(['userInfo', 'setting'])
  },
  name: 'CleanStatistic',
  components: { 'chart-container': ChartContainer, 'head-panel': HeadPanel },
  data() {
    return {
      statData: null,
      config: null,
      condition: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        enterpriseCode: '',
        dateType: 'month'
      }
    }
  },
  created() {
    this.config = {
      height: this.calculateHeight(),
      width: document.documentElement.clientWidth - 210,
      space: 5,
      head: {
        height: 50
      }
    }
    this.config.unit = (this.config.height - this.config.space * 4) / 3

    this.condition.enterpriseCode = this.userInfo.enterpriseCode
    this.getStatData()
  },
  methods: {
    calculateHeight() {
      // 减去头部和图片区域高度
      return document.documentElement.clientHeight - 60
    },
    async getStatData() {
      this.statData = await this.$lgh.get('api/clean/statistic/get-all', this.condition)
    },
    change(data) {
      Object.assign(this.condition, data)
      this.getStatData()
    },
    previewImage(url) {
      this.$utils.previewImage([url], 0)
    }
  }
}
</script>
<style lang="less" scoped>
.page-bg {
  background-color: #111;
}

</style>
